// extracted by mini-css-extract-plugin
export default {"swiperContainer":"PhotoCarousel_swiperContainer__VzQp1","swiper-slide":"PhotoCarousel_swiper-slide__PGPBd","swiper":"PhotoCarousel_swiper__CrB92"};